import { render, staticRenderFns } from "./NoData2.vue?vue&type=template&id=279bc774&scoped=true"
import script from "./NoData2.vue?vue&type=script&lang=js"
export * from "./NoData2.vue?vue&type=script&lang=js"
import style0 from "./NoData2.vue?vue&type=style&index=0&id=279bc774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279bc774",
  null
  
)

export default component.exports